<script>
import { Menu } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'

export default {
  mixins: [ListMixin],
  data() {
    return {
      editRouteName: 'Edit Menu',
      verboseName: 'Menu',
      verboseNamePlural: 'Menu',
      listFields: [
        { prop: 'id', label: 'id', width: 80 },
        { prop: 'name', label: 'nazwa' },
        { prop: 'place', label: 'umiejscowienie' }
      ]
    }
  },
  computed: {
    service() {
      return Menu
    }
  }
}
</script>
